import styled from 'styled-components';

import { borderRadius, typography } from '@atlaskit/theme';
import { SpotlightPulse } from '@atlaskit/onboarding';

const SpotlightHeading = styled.p`
  ${typography.h400};
  font-weight: 300;
  margin-top: -20px;
  color: inherit;
`;

const Pulse = styled(SpotlightPulse)`
  position: static;
  border-radius: ${borderRadius}px;
`;

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
`;

export { Pulse, Wrapper, SpotlightHeading };
